import { ComponentUtils } from '@/mixins';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import BehaviorAgentDirect from './BehaviorAgentDirect';
import BehaviorAgentsGroup from './BehaviorAgentsGroup';
import BehaviorVirtualDepartment from './BehaviorVirtualDepartment';

// @vue/component
export default {
  name: 'WidgetBehaviorInhours',

  components: {
    ShUserAvatar,
    BehaviorAgentDirect,
    BehaviorAgentsGroup,
    BehaviorVirtualDepartment,
  },

  mixins: [ComponentUtils],

  props: {
    type: {
      type: String,
      default: 'inhours',
    },
    behaviorTypes: {
      type: Array,
      default: () => [],
    },
    widget: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ivrMenuList() {
      return this.$store.getters['ivrMenu/list'];
    },
    agentsList() {
      return this.$store.getters['agents/list'];
    },
    departmentsList() {
      return this.$store.getters['departments/list'];
    },
    behaviorTypesAccordingToType() {
      return this.behaviorTypes.filter(item => item.type === this.type);
    },
    __type() {
      // HNIT: this simple map swaps the type for (inhours, afterhours)
      // to that required by the widget object
      return {
        inhours: 'call_behavior',
        afterhours: 'after_hours_behavior',
      }[this.type];
    },
  },

  created() {
    this.mMakeCopyFromProps('widget');
  },

  methods: {
    handleAgentDirectBehaviorChange(agentId) {
      this.mCopy.widget.config.call_behavior_agent_id = agentId;
      this.informAboutChanges();
    },
    handleAgentsGroupBehaviorChange(agentsGroup) {
      this.mCopy.widget.config.call_behavior_agents_group = agentsGroup;
      this.informAboutChanges();
    },
    handleHotlineMenuBehaviorChange(ivrMenuPath) {
      this.mCopy.widget.config.call_behavior_ivr_menu_path = ivrMenuPath;
      this.informAboutChanges();
    },
    handleVirtualBehaviorBehaviorChange(departments) {
      this.mCopy.widget.config.call_behavior_virtual_departments = departments;
      this.informAboutChanges();
    },
    informAboutChanges() {
      this.$emit('change', this.mCopy.widget);
    },
  },
};
